"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _default = exports.default = _vue.default.extend({
  data() {
    return {
      sidebarOpen: false,
      // sidebarSection may contain: '', 'user', 'settings', 'nicklist', 'about', 'component'
      sidebarSection: '',
      sidebarUser: null,
      activeComponent: null,
      activeComponentProps: null,
      // Composant de sidebar mémorisé quand on ouvre un profil par-dessus (ex.
      // navigateur de recherche ASL) : on y revient à la fermeture du profil
      // au lieu de fermer la sidebar. Voir showUser() / close().
      previousComponent: null,
      previousComponentProps: null
    };
  },
  computed: {
    isDrawn() {
      return this.sidebarOpen && this.section() && this.$state.ui.app_width <= 769;
    },
    isOpen() {
      return this.sidebarOpen && this.section() && this.$state.ui.app_width > 769;
    }
  },
  created() {
    this.listen(this.$state, 'sidebar.component', (component, props) => {
      if (!component) {
        // Fermeture d'un composant (ex. navigateur d'utilisateurs) :
        // close() ramène à la nicklist sur desktop/salon.
        this.close();
        return;
      }
      this.resetSidebarState();
      this.sidebarOpen = true;
      this.activeComponent = component;
      this.activeComponentProps = props || {};
      this.sidebarSection = 'component';
    });

    // Fermeture au clic extérieur des panneaux de sidebar. Deux régimes :
    //  • Mobile (≤769) : tout panneau ouvert (nicklist/profil/paramètres/à propos)
    //    est un tiroir/modal par-dessus le chat → un clic dehors le ferme.
    //  • Desktop (>769) : la nicklist est le panneau permanent ; seules les vues
    //    transitoires (paramètres / à propos / navigateur d'utilisateurs, + profil
    //    en modal salon) reviennent à la nicklist au clic dehors.
    // Dans les deux cas on EXCLUT le panneau lui-même (.app-sidebar) et les barres
    // qui l'ouvrent (.app-global-actions topbar ; .app-mobile-nav sur
    // mobile) sinon le clic d'ouverture le refermerait aussitôt.
    this.listen(this.$state, 'document.clicked', e => {
      let target = e && e.target;
      if (!target || !target.closest) {
        return;
      }

      // Mobile : les panneaux (nicklist, profil, paramètres, à propos)
      // s'ouvrent en tiroir/modal par-dessus le chat. Un clic en dehors du
      // panneau ET des barres qui les ouvrent (navbar mobile du bas + actions
      // topbar) doit les fermer → retour au chat. On EXCLUT .app-mobile-nav
      // sinon le clic sur « En ligne » (qui vient d'ouvrir la nicklist)
      // remonterait jusqu'ici et la refermerait aussitôt.
      if (this.$state.ui.app_width <= 769) {
        if (!this.section()) {
          return;
        }
        if (target.closest('.app-sidebar') || target.closest('.app-mobile-nav') || target.closest('.app-global-actions') || target.closest('.app-header') || target.closest('.app-statebrowser')) {
          // .app-statebrowser : surface qui LANCE des panneaux sidebar
          // (liste des salons, radio) — un clic dessus ne doit pas refermer
          // le panneau qu'il vient d'ouvrir (sinon on retombe sur le chat).
          // .app-header : en-tête du buffer (ContainerHeader) — en message
          // privé, l'icône profil (fa-user → toggleUser) y vit ; sans cette
          // exclusion, le clic ouvre le profil puis le referme aussitôt
          // (équivalent de .app-global-actions pour les salons).
          return;
        }
        this.close();
        return;
      }
      let section = this.section();
      // Le profil ('user') se ferme au clic extérieur UNIQUEMENT en salon, où
      // il s'affiche en modal. En privé (PM) il est docké (panneau permanent)
      // → on ne le ferme pas.
      let buffer = this.$state.getActiveBuffer();
      let isUserModal = section === 'user' && buffer && buffer.isChannel();
      if (section !== 'settings' && section !== 'about' && section !== 'component' && !isUserModal) {
        return;
      }
      if (target.closest('.app-sidebar') || target.closest('.app-global-actions')) {
        return;
      }
      // close() revient au composant précédent (navigateur ASL) s'il y en a un,
      // sinon nicklist sur desktop-salon.
      this.close();
    });

    // Ouvre la nicklist par défaut sur desktop (nextTick : app_width vaut 0 au created).
    this.$nextTick(() => {
      if (this.$state.ui.app_width > 769) {
        this.sidebarOpen = true;
        if (!this.sidebarSection) {
          this.sidebarSection = this.$state.setting('sidebarDefault') || 'nicklist';
        }
      }
    });

    // Retour en vue desktop (redimensionnement, ex. via l'inspecteur) : la
    // nicklist est le panneau permanent sur desktop → on la réaffiche si plus
    // rien n'est ouvert (elle avait pu être fermée pendant la vue mobile). Sans
    // ça, en repassant mobile → desktop, le panneau droit restait vide.
    this.$watch(() => this.$state.ui.app_width, (newWidth, oldWidth) => {
      if (newWidth > 769 && oldWidth <= 769 && !(this.sidebarOpen && this.section())) {
        this.showNicklist();
      }
    });
  },
  methods: {
    section() {
      if (!this.sidebarOpen) {
        return '';
      }
      let section = this.sidebarSection;
      if (section === 'component') {
        return section;
      }
      let buffer = this.$state.getActiveBuffer();
      // getActiveBuffer() peut être null (aucun salon actif : vue active
      // radio/paramètres, état transitoire…). Sans garde, buffer.isQuery()
      // lève un TypeError à chaque clic via le handler 'document.clicked'.
      if (!buffer) {
        return '';
      }
      if (buffer.isQuery()) {
        // This is a query with only one possible sidebar dont change the current state
        // instead attempt to show the user, this allows channels to show their nicklist
        let user = this.$state.getUser(buffer.getNetwork().id, buffer.name);
        if (user) {
          this.sidebarUser = user;
          return 'user';
        }
        return '';
      }

      // The following code is for channels only
      if (!buffer.isChannel()) {
        return '';
      }
      if (section === 'user' && this.sidebarUser) {
        if (buffer.hasNick(this.sidebarUser.nick)) {
          return 'user';
        }
        // This was going to show a user that is not even present in the current channel
        // permantly switch back to nicklist so it does not jump back to user
        // when they switch to a channel with that user
        this.sidebarSection = 'nicklist';
        return this.sidebarSection;
      } else if (section === 'nicklist') {
        return 'nicklist';
      } else if (section === 'settings') {
        return 'settings';
      } else if (section === 'about') {
        return 'about';
      }
      return '';
    },
    resetSidebarState() {
      this.sidebarOpen = false;
      this.sidebarSection = '';
      this.sidebarUser = null;
      this.activeComponent = null;
      this.activeComponentProps = null;
      this.previousComponent = null;
      this.previousComponentProps = null;
    },
    isDesktop() {
      return this.$state.ui.app_width > 769;
    },
    close() {
      // Si on fermait un profil ouvert PAR-DESSUS un composant (navigateur de
      // recherche ASL…), on y revient au lieu de fermer la sidebar.
      let prevComponent = this.previousComponent;
      let prevProps = this.previousComponentProps;
      if (prevComponent) {
        this.resetSidebarState();
        this.sidebarOpen = true;
        this.activeComponent = prevComponent;
        this.activeComponentProps = prevProps || {};
        this.sidebarSection = 'component';
        return;
      }
      let buffer = this.$state.getActiveBuffer();
      if (this.isDesktop() && buffer && buffer.isChannel()) {
        // Desktop : sur un salon, la nicklist reste toujours affichée.
        this.showNicklist();
        return;
      }
      this.resetSidebarState();
    },
    showUser(user) {
      // Mémorise le composant actif (ex. navigateur de recherche ASL) avant de
      // basculer sur le profil, pour y revenir à la fermeture (cf. close()).
      let prevComponent = this.activeComponent;
      let prevProps = this.activeComponentProps;
      this.resetSidebarState();
      this.sidebarOpen = true;
      this.sidebarUser = user;
      this.sidebarSection = 'user';
      this.previousComponent = prevComponent;
      this.previousComponentProps = prevProps;
    },
    showNicklist() {
      this.resetSidebarState();
      this.sidebarOpen = true;
      this.sidebarSection = 'nicklist';
    },
    showBufferSettings() {
      this.resetSidebarState();
      this.sidebarOpen = true;
      this.sidebarSection = 'settings';
    },
    showAbout() {
      this.resetSidebarState();
      this.sidebarOpen = true;
      this.sidebarSection = 'about';
    },
    toggleUser(user) {
      this.section() === 'user' ? this.close() : this.showUser(user);
    },
    toggleNicklist() {
      if (this.isDesktop()) {
        // Desktop : la nicklist ne se ferme pas, on la (ré)affiche.
        this.showNicklist();
        return;
      }
      this.section() === 'nicklist' ? this.close() : this.showNicklist();
    },
    toggleBufferSettings() {
      if (this.section() === 'settings') {
        this.isDesktop() ? this.showNicklist() : this.close();
      } else {
        this.showBufferSettings();
      }
    },
    toggleAbout() {
      if (this.section() === 'about') {
        this.isDesktop() ? this.showNicklist() : this.close();
      } else {
        this.showAbout();
      }
    }
  }
});
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["SidebarState"]
window._app_exports.components.SidebarState = exports.default ? exports.default : exports;
